import * as _ from 'underscore'

import { DIRECTIVE_NAME } from './element-size-watch.directive'
import { IMRBaseControlDirectiveController } from '../base'


// Public Types

export type IMRElementSizeWatchOptions = {
    onResize(): void
}

// Public Types End


export class IMRElementSizeWatchController extends IMRBaseControlDirectiveController {

    // Ctor

    constructor(private $scope: any, private $element: JQuery) {
        super()
        
        $scope.$watch(() => {
            const height: number = this.$element.height()
            const width: number = this.$element.width()

            return `${width}x${height}`
        }, _.debounce(() => this.onResize(), 200))
    }

    // Ctor End


    // Events

    private onResize(): void {
        if (this.$scope[DIRECTIVE_NAME] != null && _.isFunction(this.$scope[DIRECTIVE_NAME].onResize)) {
            this.$scope[DIRECTIVE_NAME].onResize()
        }
    }

    // Events End
}
